import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"

const CreateDoctorModal = ({ isOpen, onClose, onSave, loading }) => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const mode = useSelector(state => state.Layout.layoutMode)

  const [form, setForm] = useState({
    organizationId: activeOrganization?.id,
    firstName: "",
    lastName: "",
    athenaDoctorId: "",
    email: "",
    googleReviewLink: "",
  })

  // Reset form when modal opens or organization changes
  useEffect(() => {
    if (isOpen && activeOrganization) {
      setForm({
        organizationId: activeOrganization.id,
        firstName: "",
        lastName: "",
        athenaDoctorId: "",
        email: "",
        googleReviewLink: "",
      })
    }
  }, [isOpen, activeOrganization])

  if (!isOpen) return null

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (loading) return // avoid double submit while saving

    if (typeof onSave === "function") {
      onSave(form) // send data to parent (API call, etc.)
    }
  }

  const handleClose = () => {
    if (loading) return // optional: block closing while saving
    onClose && onClose()
  }

  return (
    <div style={backdropStyle}>
      <div
        style={{
          ...modalStyle,
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
        }}
      >
        <div style={headerStyle}>
          <h2 style={{ margin: 0 }}>Create Entity</h2>
          <button
            style={closeBtnStyle}
            onClick={handleClose}
            type="button"
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={fieldStyle}>
            <label style={labelStyle} htmlFor="firstName">
              First Name
            </label>
            <input
              id="firstName"
              name="firstName"
              type="text"
              value={form.firstName}
              onChange={handleChange}
              style={inputStyle}
              required
              disabled={loading}
            />
          </div>

          <div style={fieldStyle}>
            <label style={labelStyle} htmlFor="lastName">
              Last Name
            </label>
            <input
              id="lastName"
              name="lastName"
              type="text"
              value={form.lastName}
              onChange={handleChange}
              style={inputStyle}
              required
              disabled={loading}
            />
          </div>

          <div style={fieldStyle}>
            <label style={labelStyle} htmlFor="athenaDoctorId">
              Employee ID
            </label>
            <input
              id="athenaDoctorId"
              name="athenaDoctorId"
              type="text"
              value={form.athenaDoctorId}
              onChange={handleChange}
              style={inputStyle}
              disabled={loading}
            />
          </div>

          <div style={fieldStyle}>
            <label style={labelStyle} htmlFor="email">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              style={inputStyle}
              disabled={loading}
            />
          </div>

          {/* <div style={fieldStyle}>
            <label style={labelStyle} htmlFor="googleReviewLink">
              Google Review Link
            </label>
            <textarea
              id="googleReviewLink"
              name="googleReviewLink"
              value={form.googleReviewLink}
              onChange={handleChange}
              style={{ ...inputStyle, minHeight: 70, resize: "vertical" }}
              disabled={loading}
            />
          </div> */}

          <div style={footerStyle}>
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              style={{
                ...buttonStyle,
                backgroundColor: "#e5e7eb",
                color: "#111827",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                ...buttonStyle,
                backgroundColor: "#2990DF",
                color: "#ffffff",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Saving..." : "Save Entity"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

/* ------------ Inline styles (you can swap to CSS if you like) ------------ */

const backdropStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
}

const modalStyle = {
  backgroundColor: "#ffffff",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "480px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  padding: "20px 24px 24px",
  boxSizing: "border-box",
}

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",
}

const closeBtnStyle = {
  border: "none",
  background: "transparent",
  fontSize: "22px",
  cursor: "pointer",
  lineHeight: 1,
}

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}

const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}

const labelStyle = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#374151",
}

const inputStyle = {
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  padding: "8px 10px",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
}

const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  marginTop: "16px",
}

const buttonStyle = {
  border: "none",
  borderRadius: "8px",
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: 500,
  cursor: "pointer",
}

export default CreateDoctorModal
